import React from "react";
import PropTypes from "prop-types";

export default function Eye(props) {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1015 5C15.1015 6.23975 14.6248 7.3566 13.8475 8.20881C14.7607 7.8433 15.5996 7.38609 16.3354 6.91429C17.4981 6.16873 18.3622 5.41306 18.8014 5C18.3622 4.58695 17.498 3.83127 16.3354 3.08571C15.5996 2.61392 14.7607 2.15672 13.8476 1.79122C14.6248 2.64342 15.1015 3.76026 15.1015 5ZM19.8506 5.37056C20.0498 5.15952 20.0498 4.84048 19.8506 4.62944C19.6721 4.44063 15.3781 0 9.99999 0C4.62186 0 0.327881 4.44063 0.149327 4.62944C-0.0497756 4.84048 -0.0497756 5.15952 0.149327 5.37056C0.327843 5.55937 4.62178 10 9.99999 10C15.3782 10 19.6721 5.55937 19.8506 5.37056ZM3.66457 6.91429C2.50187 6.16872 1.63777 5.41303 1.19854 5.00001C1.63781 4.58696 2.50192 3.83127 3.66461 3.08571C4.40037 2.61392 5.23927 2.15672 6.15241 1.79122C5.37516 2.64342 4.89843 3.76026 4.89843 5C4.89843 6.23975 5.37517 7.3566 6.15243 8.20881C5.23927 7.8433 4.40034 7.38609 3.66457 6.91429ZM9.99999 1.11111C12.2614 1.11111 14.1015 2.85589 14.1015 5C14.1015 7.14411 12.2614 8.88889 9.99999 8.88889C7.73862 8.88889 5.89843 7.14411 5.89843 5C5.89843 2.85589 7.73862 1.11111 9.99999 1.11111ZM10.0003 2.8125C8.72575 2.8125 7.69256 3.79188 7.69256 5C7.69256 6.20812 8.72575 7.1875 10.0003 7.1875C11.2748 7.1875 12.3079 6.20812 12.3079 5C12.3079 3.79188 11.2748 2.8125 10.0003 2.8125Z"
        fill={props.fill}
      />
    </svg>
  );
}
Eye.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
Eye.defaultProps = {
  fill: "#C7CCD2",
  width: 20,
  height: 10
};
